/**
 * VI-784 — attribution switch for the `replaceChild` NotFoundError storm.
 *
 * The throw itself happens inside the shared theme bundle (`900.chunk.min.js`), between the
 * converter capturing a parent and calling `replaceChild` on it. We have two app-side guards that
 * also touch the same DOM (`reactDomNodeGuard`, `platformIconGuard`), so "is any of the remaining
 * error volume ours?" was guesswork. This makes it measurable instead:
 *
 *     /v1/recruiter/?jtNoIconGuards=1     -> both guards disabled for that page load
 *
 * Compare the console error count with and without the flag. Equal counts mean the residual is
 * entirely upstream (PA-1976) and no further app-side change can reduce it. A lower count with the
 * flag means one of our guards is still contributing and we keep digging.
 *
 * Diagnostic only — delete alongside the guards once PA-1976 ships.
 */
export const iconGuardsDisabled = (): boolean => {
  try {
    if (typeof window === 'undefined') return false;
    return new URLSearchParams(window.location.search).get('jtNoIconGuards') === '1';
  } catch {
    return false;
  }
};
